module.exports = __webpack_public_path__ + "img/projects.57dcb4a0.svg";